import "./Arinnovation.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../Images/button.png";
import in1 from "../Images/in1.png";
import in2 from "../Images/in2.png";
import in3 from "../Images/in3.png";
import in4 from "../Images/in4.png";
import in5 from "../Images/in5.png";
import in6 from "../Images/in6.png";
const Arinnovation = () => {
  const data = [
    {
      id: 1,
      image: in1,
      image2: in2,
      title: "Metaspace – Step Into the Metaverse",
      italicText:
        "An Immersive Virtual World Built for Exploration, Commerce, and Culture",
      text: "Enter a limitless virtual world. Metaspace offers VR concerts and games all inside an immersive, social metaverse.",
    },
    {
      id: 2,
      image: in3,
      image2: in4,
      title: "Vuezen– AR Lookbooks for Timeless Eyewear",
      italicText: "Where Optical Precision Meets Augmented Elegance",
      text: "Experience eyewear like never before. Vuezen uses AR try-ons to let customers explore frames in 3D, combining fashion, clarity, and innovation.",
    },
    {
      id: 3,
      image: in5,
      image2: in6,
      title: "Sheluxe – Elegance Enhanced with Virtual Touch",
      italicText: "Luxury Lingerie Meets Immersive Try-On Experiences",
      text: "Luxury meets tech. Sheluxe uses AR to offer virtual lingerie try-ons with stunning detail designed to celebrate comfort, confidence, and style.",
    },
  ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow"/>
  };
  return (
    <div id="arinnovation" className="divWrapper">
      <div className="arvrcontainer innovationContainer">
         <h2 className="heading" style={{color:"#9747ff"}}>
          AR/VR Innovation That Transforms Brands Into Experiences
        </h2>
        <Slider {...settings}>
          {data.map((item) => {
            return (
              <div className="inWrapper" key={item.id}>
                <div className="inBox">
                  <div className="leftbox">
                    <img src={item.image} alt="" />
                  </div>
                  <div className="rightbox">
                    <div className="rightImgbox">
                      <img src={item.image2} alt="" />
                    </div>
                    <h2>{item.title}</h2>
                    <p className="italicP">{item.italicText}</p>
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Arinnovation;
